import { toast } from '@/components/ui/toaster'

export type AssetUploadKind = 'image' | 'video' | 'all'

const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
]

const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/webm',
  'video/quicktime',
]

const VALID_MIME_TYPES: Record<AssetUploadKind, string[]> = {
  image: IMAGE_MIME_TYPES,
  video: VIDEO_MIME_TYPES,
  all: [...IMAGE_MIME_TYPES, ...VIDEO_MIME_TYPES],
}

const UPLOAD_COPY: Record<AssetUploadKind, string> = {
  image: 'images',
  video: 'videos',
  all: 'images and videos',
}

export const MAX_ASSET_UPLOAD_SIZE_BYTES = 50 * 1024 * 1024

export function getAssetUploadAccept(kind: AssetUploadKind = 'all'): string {
  if (kind === 'image') return 'image/*'
  if (kind === 'video') return 'video/*'
  return 'image/*,video/*'
}

export function validateAssetFiles(
  files: File[],
  kind: AssetUploadKind = 'all'
): File[] {
  const validMimeTypes = VALID_MIME_TYPES[kind]

  return files.filter((file) => {
    if (!validMimeTypes.includes(file.type)) {
      toast({
        title: 'Invalid file type',
        description: `${file.name} is not a supported format (${UPLOAD_COPY[kind]} only)`,
        variant: 'destructive',
      })
      return false
    }

    if (file.size > MAX_ASSET_UPLOAD_SIZE_BYTES) {
      toast({
        title: 'File too large',
        description: `${file.name} exceeds the 50MB limit`,
        variant: 'destructive',
      })
      return false
    }

    return true
  })
}
